/**
 * @generated SignedSource<<a0ae114408c55711729b3cb6bed324b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetails_user$data = {
  readonly canShowSellerName?: boolean | null;
  readonly " $fragmentType": "ProductDetails_user";
};
export type ProductDetails_user$key = {
  readonly " $data"?: ProductDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetails_user",
  "selections": [
    {
      "condition": "showSeller",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canShowSellerName",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "59e40cc983558dd28dde3d9fbb49773a";

export default node;
